import { createSelector } from '@ngrx/store';
import { IAppState } from '../state/app.state';
import { ISavedSearchState } from '../state/savedSearch.state';

const SavedSearches = (state: IAppState) => state.savedSearch;

export const selectSavedSearches = createSelector(SavedSearches, (state: ISavedSearchState) => state.searchesArray);

export const selectSavedSearchesLoaded = createSelector(SavedSearches, (state: ISavedSearchState) => state.loaded);
